import { render, staticRenderFns } from "./GlobalApiChangesExampleAfter.vue?vue&type=template&id=d1bb953a&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports